interface ObjectData {
  [key: string]: ObjectData | string;
}

enum SubmissionKind {
  partial = 'partial',
  close = 'close',
  complete = 'complete',
}

enum FormType {
  C = 'C', // Check-in forms (intake)
  S = 'S', // Schedule forms for creating appointments in doctor partnership’s EMRs
}

export interface FormIntakeSubmission {
  formName: string;
  formPath: string;
  formType: FormType;
  slug: string;
  kind: SubmissionKind;
  sessionId: string; //uuid
  page: number;
  pageTitle: string;
  data: ObjectData;
}

export interface CreateAndSendEmailBody {
  email: string;
  accountId: string;
  promoCode: string;
  hasExistingAccount: boolean;
}
